import React from 'react';
import { Link } from 'gatsby';
import classnames from 'classnames';

import { useSteppedLetterAnimation } from '../hooks/useSteppedLetterAnimation';

import * as css from './Button.module.css';

const Button = ({
  className,
  to,
  href,
  label,
  size = 'default',
  target,
  disabled,
  handleClick
}) => {
  const [ref, actions] = useSteppedLetterAnimation({
    text: label,
    duration: label.length * 0.5
  });
  //
  const buttonCssClasses = classnames(
    css.button,
    {
      [css.small]: size === 'small',
      [css.xSmall]: size === 'x-small',
      [css.disabled]: disabled
    },
    className
  );

  return to ? (
    <Link
      to={to}
      ref={ref}
      className={buttonCssClasses}
      onClick={handleClick}
      onMouseEnter={actions.toggle}
      onMouseLeave={actions.toggle}>
      {label}
    </Link>
  ) : href ? (
    <a
      href={href}
      target={target}
      ref={ref}
      className={buttonCssClasses}
      onClick={handleClick}
      onMouseEnter={actions.toggle}
      onMouseLeave={actions.toggle}>
      {label}
    </a>
  ) : (
    <button
      ref={ref}
      className={buttonCssClasses}
      type="button"
      onClick={handleClick}
      onMouseEnter={actions.toggle}
      onMouseLeave={actions.toggle}>
      {label}
    </button>
  );
};

export default Button;
